import { create } from 'zustand';
import { BrowserStorage } from 'utils/browserStorage';

const readDismissed = (): boolean => {
  try {
    return (
      sessionStorage.getItem(
        BrowserStorage.keys.Invitations.PendingModalDismissed,
      ) === '1'
    );
  } catch {
    return false;
  }
};

const persistDismissed = () => {
  try {
    sessionStorage.setItem(
      BrowserStorage.keys.Invitations.PendingModalDismissed,
      '1',
    );
  } catch {
    // sessionStorage unavailable: the dismissal then lasts for this page load only
  }
};

type PendingInvitationState = {
  openAccountId: number | null;
  dismissed: boolean;
  open(accountId: number): void;
  close(): void;
};

const usePendingInvitationStore = create<PendingInvitationState>((set) => ({
  openAccountId: null,
  dismissed: readDismissed(),
  open: (accountId) => set({ openAccountId: accountId }),
  close: () => {
    persistDismissed();
    set({ openAccountId: null, dismissed: true });
  },
}));

export default usePendingInvitationStore;
